import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { BRAND, GRAY, WHATSAPP } from "../colors";

export const WhatsAppAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const phoneScale = spring({ frame, fps, config: { damping: 14 } });
  const notifSlide = spring({ frame: frame - 25, fps, config: { damping: 12 } });
  const msgExpand = spring({ frame: frame - 55, fps, config: { damping: 14 } });
  const replySlide = spring({ frame: frame - 80, fps, config: { damping: 14 } });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: GRAY[50],
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Phone mockup */}
      <div
        style={{
          transform: `scale(${phoneScale})`,
          width: 320,
          height: 420,
          borderRadius: 32,
          border: `4px solid ${GRAY[800]}`,
          backgroundColor: "white",
          overflow: "hidden",
          position: "relative",
          boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
        }}
      >
        {/* Status bar */}
        <div
          style={{
            height: 32,
            backgroundColor: WHATSAPP.darkGreen,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: 60,
              height: 6,
              borderRadius: 3,
              backgroundColor: "rgba(255,255,255,0.3)",
            }}
          />
        </div>

        {/* WhatsApp header */}
        <div
          style={{
            height: 44,
            backgroundColor: WHATSAPP.darkGreen,
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${BRAND[400]}, ${BRAND[600]})`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13,
              color: "white",
              fontWeight: 700,
            }}
          >
            OT
          </div>
          <span style={{ color: "white", fontSize: 17, fontWeight: 600 }}>OneTapReply</span>
        </div>

        {/* Chat area */}
        <div
          style={{
            flex: 1,
            backgroundColor: WHATSAPP.chatBg,
            padding: 14,
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          {/* Notification bubble */}
          <div
            style={{
              transform: `translateY(${interpolate(notifSlide, [0, 1], [20, 0])}px)`,
              opacity: notifSlide,
              backgroundColor: "white",
              borderRadius: 10,
              padding: "12px 14px",
              maxWidth: "90%",
              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
            }}
          >
            <div style={{ fontSize: 14, fontWeight: 700, color: BRAND[600], marginBottom: 6 }}>
              📝 New Review · Sunrise Dental
            </div>
            <div style={{ fontSize: 14, color: GRAY[700], lineHeight: 1.4 }}>
              <span style={{ color: "#F59E0B" }}>★★★★★</span> &quot;Best dentist in Miami!
              Very professional and quick.&quot;
            </div>
          </div>

          {/* Suggested reply */}
          <div
            style={{
              transform: `translateY(${interpolate(msgExpand, [0, 1], [20, 0])}px)`,
              opacity: msgExpand,
              backgroundColor: "white",
              borderRadius: 10,
              padding: "12px 14px",
              maxWidth: "90%",
              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
            }}
          >
            <div style={{ fontSize: 14, fontWeight: 700, color: BRAND[600], marginBottom: 6 }}>
              💬 Suggested Reply
            </div>
            <div style={{ fontSize: 14, color: GRAY[600], lineHeight: 1.4 }}>
              &quot;Thanks for choosing Sunrise Dental in Miami! We&apos;re glad your visit was smooth. See you next time!&quot;
            </div>
          </div>

          {/* Action buttons */}
          <div
            style={{
              transform: `scale(${replySlide})`,
              opacity: replySlide,
              display: "flex",
              gap: 6,
              marginTop: 4,
            }}
          >
            {[
              { label: "✅ Approve", bg: "#22c55e" },
              { label: "✏️ Edit", bg: BRAND[500] },
              { label: "⏭️ Skip", bg: GRAY[400] },
            ].map((btn) => (
              <div
                key={btn.label}
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "white",
                  backgroundColor: btn.bg,
                  borderRadius: 14,
                  padding: "6px 12px",
                }}
              >
                {btn.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};
